// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__zWQdw","slider":"styles_slider__3DQo+","toggleDisabled":"styles_toggleDisabled__t5fJC"};